import { useCallback } from 'react';
import { trim, truncate } from 'lodash';
import { POST_MESSAGES_TYPES } from 'modules/codeless-events/consts/iframeParentConstants';
import { removeEmojis } from 'modules/codeless-events/utils/stringUtils';
import { MAX_CONVERSION_NAME_LENGTH } from '../components/SetupClicksEventCategory/ConversionNameField';
import { STEP_IDS } from '../config/stepIds';
import { useConversionActions } from './useConversionActions';

export const useHandleFinishSelection = ({
    currentConversion,
    updateDraftEvent,
    selectedButtons,
    setIsHighlighting,
    navigateToStepId,
}) => {
    const { isEventNew } = useConversionActions();

    const handleFinishSelection = useCallback(() => {
        if (updateDraftEvent && selectedButtons.length > 0) {
            const isNew = isEventNew(currentConversion.id);

            const firstButton = selectedButtons[0];
            const conversionName = truncate(trim(removeEmojis(firstButton.displayText)), {
                length: MAX_CONVERSION_NAME_LENGTH,
                omission: '',
            });
            const eventName = isNew ? removeEmojis(firstButton.displayText) : undefined;

            const updatePayload = {
                trackedElements: selectedButtons,
                conversionName,
            };

            if (eventName) {
                updatePayload.eventName = eventName;
            }

            updateDraftEvent(draft => ({
                ...draft,
                ...updatePayload,
            }));
        }

        window.parent.postMessage({ type: POST_MESSAGES_TYPES.FINISH_NAVIGATE }, '*');

        setIsHighlighting(false);
        if (navigateToStepId) {
            navigateToStepId(STEP_IDS.SETUP_CLICKS_EVENT_CATEGORY);
        }
    }, [updateDraftEvent, selectedButtons, currentConversion, isEventNew, setIsHighlighting, navigateToStepId]);

    return { handleFinishSelection };
};
